import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=5d71b406&scoped=true"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"
import style0 from "./Details.vue?vue&type=style&index=0&id=5d71b406&prod&scoped=scoped&lang=less"
import style1 from "./Details.vue?vue&type=style&index=1&id=5d71b406&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d71b406",
  null
  
)

export default component.exports